var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrestLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 139,
    viewBox: "0 0 121 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1 0L0 34.7V104.1L60.1 138.8L120.1 104.1V34.7L60.1 0ZM102.3 93.8L60 118.2L17.8 93.8V45L60.1 20.6L102.3 45V93.8Z",
    fill: "#002D74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1 138.8L120.1 104.1V34.7L60.1 0V20.6L102.3 45V93.9L60 118.3V138.8H60.1Z",
    fill: "url(#paint0_linear_304_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0L0 34.7V104.1L60 138.8V118.2L17.8 93.8V44.9L60 20.6V0Z",
    fill: "url(#paint1_linear_304_3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1 85.6L60.1 101.8L32 85.6V53.2L60.1 37L88.1 53.2L76.4 60L60 50.5L43.7 60V78.9L60.1 88.4L76.5 78.9L88.1 85.6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_3",
    x1: 90.1166,
    y1: 138.803,
    x2: 90.1166,
    y2: 69.4014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0042AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_304_3",
    x1: 30.0233,
    y1: 0,
    x2: 30.0233,
    y2: 69.4014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0042AA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.1,
    height: 138.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrestLogoLight);
export default __webpack_public_path__ + "static/media/crest-logo-light.4c2ba90edc401fbed5e171e72a640073.svg";
export { ForwardRef as ReactComponent };